import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "project-overview-main__video-modal abs"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "flex column al-center",
  "data-scroll": "",
  "data-scroll-speed": "2.3"
}
const _hoisted_6 = { class: "subt-design luxury uppercase c-white mb-13 wc-lg" }
const _hoisted_7 = { class: "t-design luxury uppercase c-white wc-lg" }
const _hoisted_8 = {
  key: 1,
  class: "flex column al-center",
  "data-scroll": "",
  "data-scroll-speed": "2.3"
}
const _hoisted_9 = { class: "t-design luxury uppercase c-white wc-lg" }
const _hoisted_10 = { class: "subt-design luxury uppercase c-white mb-13 wc-lg" }
const _hoisted_11 = {
  key: 2,
  id: "projectOverviewFixedTarget",
  class: "abs"
}
const _hoisted_12 = { class: "rel" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "project-overview-main__scroll--line abs" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bg-t-red" })
], -1)
const _hoisted_16 = { class: "project-overview-main__scroll--ttl fira f-menu uppercase c-white" }
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "f-menu c-white uppercase bold" }

import func from "@/helpers/func";
import { useMenuStore } from "@/store/pinia/menu";
import { ref, onMounted, watch, computed, onUnmounted, nextTick } from "vue";
import type { Ref } from "vue";
import ProjectOverviewMainLeftCol from "./Parts/ProjectOverviewMain.leftCol.vue";
import { handleResize } from "@/composables/resizeHandler";
import { useRoute, useRouter } from "vue-router";
import { lerpFn } from "@/composables/lerpFn";
import clearTimeoutHandler from "@/composables/clearTimeoutHandler";
import { keyIcon, burgerCloseIcon } from "@/components/UI/svgs";
import { MenuItem } from "@/store/ts/interfaces/state.interface";


export default /*#__PURE__*/_defineComponent({
  props: {
  contentData: {
    type: Object,
  }
},
  setup(__props) {

const props = __props



// STORE
const store = useMenuStore();
// store.disableScrollStatus = true;

// ROUTE
const route = useRoute();
const router = useRouter();

// COMPOSABLES
const { windowWidth, windowHeight } = handleResize();

// REFS
const mouseHoverDebounceTO = ref(null);
const videoCloseTO = ref(null);
const svgRender: Ref<string> = ref("");
const mainImage: Ref<string> = ref("");
const projectData = ref(null);
const svgRenderHeight = ref(null);
const appHeight = ref(0);
const pageYoffset = ref(0);


const hasScrolled = ref(false);
const circleRad = ref(270);
const isHovered = ref(false);
const isVideoOpen = ref(false);
const circleMouseRF = ref(null)
const selectedCircle = ref(null)
const isLeftColShown = ref(false);
const oldCoordX = ref(0);
const oldCoordY = ref(0);
const newCoordX = ref(0);
const newCoordY = ref(0);
const hasScrolledValue = ref(0);
const calcStickyValue = ref(0);

const renderImageChangeTO = ref(null);
const handleCirclesTO = ref(null);

let headers = computed(() => props.contentData?.conf?.header || {});
const isReverse = computed(() => props.contentData?.conf?.componentMainConfigs?.conf?.includes('reverse-title'))
// METHODS
const getProjectData = async () => {
    const res = await func.postData("dev/getProjects", { slug: route.params.path2 });
    if (windowWidth.value >= 1200) {
        svgRender.value = res?.data[0]?.render?.tabs[0]?.render_svg;

    }
    mainImage.value = res?.data[0]?.images[0]?.url;
    projectData.value = res?.data[0];

};

const setMouseNewCoords = (e: MouseEvent): void => {
    if (!selectedCircle.value) return;
    if (isHovered.value) {
        newCoordX.value = (e.clientX - selectedCircle.value.getBoundingClientRect().left + 100) * 2.6;
        newCoordY.value = (e.clientY - selectedCircle.value.getBoundingClientRect().top + 100) * 2.6;
    } else {
        newCoordX.value = (windowWidth.value - selectedCircle.value.getBoundingClientRect().left) * 1;
        newCoordY.value = ((selectedCircle.value.offsetHeight) - selectedCircle.value.getBoundingClientRect().top) * 1;
    }

}

const setNewDivCoords = (): void => {
    const r = 270;
    circleMouseRF.value = window.requestAnimationFrame(setNewDivCoords);
    oldCoordX.value = lerpFn(oldCoordX.value, newCoordX.value, 0.15);
    oldCoordY.value = lerpFn(oldCoordY.value, newCoordY.value, 0.15);
    if (!selectedCircle.value) return;
    selectedCircle.value.style.transform = `translate3d(${((oldCoordX.value - r) / 2) * 0.1
        }px, ${((oldCoordY.value - r) / 2) * 0.1}px, 0px)`;


}
setNewDivCoords();

const handleMouseLeave = () => {
    clearTimeout(mouseHoverDebounceTO.value)
    isHovered.value = false;
}


const handleMouseEnter = () => {
    clearTimeout(mouseHoverDebounceTO.value)
    mouseHoverDebounceTO.value = window.setTimeout(() => {

        isHovered.value = true;
    }, 50);

}

const handleCircles = () => {
    const svgParent = document.querySelector<HTMLElement>('.project-overview-main__render')

    const paths = document.querySelectorAll<HTMLElement>('.project-overview-main__render svg path')
    paths.forEach((path: HTMLElement) => {
        const newDiv = document.createElement("div");

        newDiv.innerHTML = `
            <div class="project-overview-main__render--circle__inner">
                <div>${path.getAttribute('svg')}</div>
                    <div class="luxury project-overview-main__render--circle__ttl c-primary uppercase wc-lg">
                        ${path.getAttribute(store.locale === 'ge' ? 'title_ge' : store.locale === 'en' ? 'title_en' : 'title_ru')}
                    </div>

                <div class="flex column al-center">
                    <svg width="28" height="11" viewBox="0 0 28 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="1.25098" y1="5.5" x2="26.251" y2="5.5" stroke="#182236" stroke-linecap="round"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.9756 0.218756L27.5409 4.97188C27.821 5.26355 27.821 5.73645 27.5409 6.02812L22.9756 10.7812C22.6954 11.0729 22.2412 11.0729 21.9611 10.7812C21.6809 10.4896 21.6809 10.0167 21.9611 9.72499L26.0191 5.5L21.9611 1.27501C21.6809 0.98333 21.6809 0.510431 21.9611 0.218756C22.2412 -0.0729188 22.6954 -0.0729188 22.9756 0.218756Z" fill="#182236"/>
                    </svg>
                    <span class="uppercase fira">
                        ${func.tr('Explore')}
                    </span>
                </div>

            </div>
        `

        newDiv.classList.add('project-overview-main__render--circle');
        newDiv.classList.add('abs');
        newDiv.style.left = `${(path.getBoundingClientRect().left + path.getBoundingClientRect().width / 2) - (circleRad.value / 2)}px`;
        newDiv.style.top = `${(path.getBoundingClientRect().top + path.getBoundingClientRect().height / 2) - (circleRad.value / 2)}px`;
        newDiv.style.opacity = '0';
        newDiv.style.pointerEvents = 'none'

        svgParent.appendChild(newDiv);
        path.addEventListener('mouseenter', () => {
            newDiv.style.opacity = '1';
            newDiv.classList.add('is-visible')
            selectedCircle.value = newDiv;
            handleMouseEnter();
        })

        path.addEventListener('mouseleave', () => {
            newDiv.style.opacity = '0';
            newDiv.classList.remove('is-visible')
            selectedCircle.value = null;
            handleMouseLeave();
        })

        const pathAttribute = path.getAttribute('url');
        if(pathAttribute?.length >= 2 ){
            path.classList.add('pointer');
            path.addEventListener('click', () => {
                if(!pathAttribute.includes('ttp') ){

                    router.push(`/${store.locale}/${path.getAttribute('url')}`);
                } else {
                    window.open(pathAttribute, '_blank');
                }
            })
        }
    })


}

const handleVideoClose = () => {
    document.querySelector<HTMLMediaElement>('.project-overview-main__video-modal').classList.add('is-closing');
    videoCloseTO.value = window.setTimeout(() => {
        isVideoOpen.value = false;

    }, 1300);
}

const getpageYoffset = () => {
    const appParent = document.querySelector<HTMLElement>('#app');
    appHeight.value = document.querySelector<HTMLElement>('.page-wrapper')?.offsetHeight;
    pageYoffset.value = appParent.scrollTop;

}

// COMPUTED
const locoY = computed(() => store.locoScrollY)

const getTitleTopPos = computed(() => {
    const textHeight = 145;
    const res: number = (windowHeight.value / 2) - (textHeight / 2);
    return res;
})

const isDark = computed(() => store.isDark)

const getApartmentsLink = computed(() => {
  return `${route.path}/apartments`
})





// MOUNTED
onMounted(() => {
    if (windowWidth.value >= 1440) {
        hasScrolledValue.value = 60;
    } else {
        hasScrolledValue.value = 40;

    }

    // store.disableScrollStatus = true;

    // await nextTick();



    if (windowWidth.value >= 1200) {

        clearTimeoutHandler(handleCirclesTO.value);
        handleCirclesTO.value = window.setTimeout(() => {
            circleMouseRF.value = window.requestAnimationFrame(setNewDivCoords);
            svgRenderHeight.value = document.querySelector<HTMLElement>('.project-overview-main__render')?.offsetHeight;
            store.headerScrolledValue = svgRenderHeight.value;
            const textWrapper = document.querySelector('.project-overview-main__left-col--text-wrapper').getBoundingClientRect().bottom;
            calcStickyValue.value = svgRenderHeight.value + (svgRenderHeight.value - (textWrapper + 60));
            document.querySelector<HTMLElement>("#projectOverviewFixedTarget").style.height = calcStickyValue.value + 'px';
            handleCircles();


            // store.triggerUpdate = !store.triggerUpdate;
            store.disableScrollStatus = true;

        }, 1100);



    }
    setTimeout(() => {
        if (windowWidth.value <= 1199) {
            const appParent = document.querySelector('#app');
            appParent.addEventListener('scroll', getpageYoffset);
        }
    }, 1100);

    setTimeout(() => {
        store.disableScrollStatus = false;

    }, 3500);
})

// UNMOUNTED

onUnmounted(() => {
    clearTimeoutHandler(mouseHoverDebounceTO.value)
    clearTimeoutHandler(handleCirclesTO.value)

    window.cancelAnimationFrame(circleMouseRF.value);
    if (windowWidth.value <= 1199) {
        const appParent = document.querySelector('#app');
        appParent.removeEventListener('scroll', getpageYoffset);
    }

})


watch(locoY, (ns) => {
    if (ns >= hasScrolledValue.value && !hasScrolled.value && windowWidth.value >= 1200) {
        hasScrolled.value = true;

        setTimeout(() => {
            isLeftColShown.value = true;
        }, 1200);
    }
})

watch(isVideoOpen, async (ns) => {
    if (ns) {
        await nextTick();
        document.querySelector<HTMLMediaElement>('.project-overview-main__video-modal video').play()
        store.getComponentCursor(null, 'zoom-cancel')

    } else {
        store.getComponentCursor(null, null)

    }

})

watch(isDark, (ns) => {
    clearTimeoutHandler(renderImageChangeTO);


    const renderBlockImage = document.querySelector<HTMLElement>('.project-overview-main__render svg image');
    const renderImage = document.querySelector<HTMLElement>('.project-overview-main__render img');

    const renderBlock = document.querySelector<HTMLElement>('.project-overview-main__render');



    renderBlock.style.opacity = '0';
    if (ns) {

        renderImageChangeTO.value = setTimeout(() => {
            renderBlock.style.opacity = '1';
            if (svgRender.value) {

                renderBlockImage.setAttribute('xlink:href', projectData.value?.images[0]?.url)

            } else {
                if (windowWidth.value >= 1200) {

                    renderImage.setAttribute('src', projectData.value?.images[0]?.url)
                } else if (windowWidth.value <= 767) {

                    renderImage.setAttribute('src', projectData.value?.mobile[0]?.devices?.mobile)
                } else if (windowWidth.value <= 1199) {

                    renderImage.setAttribute('src', projectData.value?.mobile[0]?.devices?.tablet)
                }

            }

        }, 800);
    } else {
        renderImageChangeTO.value = setTimeout(() => {
            renderBlock.style.opacity = '1';

            if (svgRender.value) {

                renderBlockImage.setAttribute('xlink:href', projectData.value?.images[1]?.url)
            } else {
                if (windowWidth.value >= 1200) {

                    renderImage.setAttribute('src', projectData.value?.images[1]?.url)
                } else if (windowWidth.value <= 767) {

                    renderImage.setAttribute('src', projectData.value?.mobile[1]?.devices?.mobile)
                } else if (windowWidth.value <= 1199) {

                    renderImage.setAttribute('src', projectData.value?.mobile[1]?.devices?.tablet)
                }

            }


        }, 800);
    }
})


getProjectData();


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (isVideoOpen.value && projectData.value?.video_url)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_unref(windowWidth) <= 1199)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "lh-0 flex al-center j-center abs",
                  innerHTML: _unref(burgerCloseIcon),
                  onClick: handleVideoClose
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true),
            _createElementVNode("video", {
              preload: "auto",
              controls: "",
              "data-scale-type": "1.5",
              "data-cursor-type": "zoom-cancel",
              onClick: _withModifiers(handleVideoClose, ["prevent"]),
              class: "pointer"
            }, [
              _createElementVNode("source", {
                src: projectData.value?.video_url,
                type: "video/mp4"
              }, null, 8, _hoisted_4)
            ], 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("section", {
      class: _normalizeClass(["project-overview-main rel ov-hidden", { 'has-scrolled': hasScrolled.value, 'ev-none': _unref(store).disableScrollStatus }]),
      onMousemove: _cache[2] || (_cache[2] = ($event: any) => (setMouseNewCoords($event)))
    }, [
      (projectData.value !== null && _unref(windowWidth) >= 1200)
        ? (_openBlock(), _createBlock(ProjectOverviewMainLeftCol, {
            key: 0,
            hasScrolled: hasScrolled.value,
            leftColData: projectData.value,
            scrollHasFinished: Math.abs(_unref(store).locoScrollY) >= _unref(windowHeight) ? true : false,
            onIsVideoOpen: _cache[0] || (_cache[0] = ($event: any) => (isVideoOpen.value = true))
          }, null, 8, ["hasScrolled", "leftColData", "scrollHasFinished"]))
        : _createCommentVNode("", true),
      (_unref(windowWidth) >= 1200)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "project-overview-main__default-overlay abs flex al-center column",
            style: _normalizeStyle({ paddingTop: _unref(getTitleTopPos) + 'px' })
          }, [
            (!_unref(isReverse))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("h2", _hoisted_6, _toDisplayString(_unref(headers).title), 1),
                  _createElementVNode("h2", _hoisted_7, _toDisplayString(_unref(headers).teaser), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("h2", _hoisted_9, _toDisplayString(_unref(headers).teaser), 1),
                  _createElementVNode("h2", _hoisted_10, _toDisplayString(_unref(headers).title), 1)
                ]))
          ], 4))
        : _createCommentVNode("", true),
      (_unref(windowWidth) >= 1200)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        (svgRender.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["project-overview-main__render rel", { 'is-left-col-shown': isLeftColShown.value }]),
              innerHTML: svgRender.value
            }, null, 10, _hoisted_13))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["project-overview-main__render rel", { 'is-left-col-shown': isLeftColShown.value }])
            }, [
              _createElementVNode("img", {
                src: _unref(windowWidth) >= 1200 ? projectData.value?.images[1].devices.desktop : _unref(windowWidth) <= 767 ? projectData.value?.mobile[1].devices.tablet : projectData.value?.mobile[1].devices.mobile
              }, null, 8, _hoisted_14)
            ], 2))
      ]),
      (_unref(windowWidth) >= 1200)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "project-overview-main__scroll flex abs",
            style: _normalizeStyle({ top: (_unref(store).locoScrollY + (_unref(windowHeight) - 250)) + 'px' })
          }, [
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(func).tr("Scroll")), 1)
          ], 4))
        : _createCommentVNode("", true),
      (projectData.value !== null && _unref(windowWidth) <= 1199)
        ? (_openBlock(), _createBlock(ProjectOverviewMainLeftCol, {
            key: 4,
            leftColData: projectData.value,
            onIsVideoOpen: _cache[1] || (_cache[1] = ($event: any) => (isVideoOpen.value = true))
          }, null, 8, ["leftColData"]))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (_unref(windowWidth) <= 1199)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: _unref(getApartmentsLink),
              class: _normalizeClass([{ 'hide-select-apartments': pageYoffset.value >=  appHeight.value - (_unref(windowHeight) + 400)}, "project-overview-main__footer flex al-center j-center bg-burgundy"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", {
                    class: "lh-0 mr-13",
                    innerHTML: _unref(keyIcon)
                  }, null, 8, _hoisted_18),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(func).tr('Select Apartments')), 1)
                ])
              ]),
              _: 1
            }, 8, ["to", "class"]))
          : _createCommentVNode("", true)
      ]))
    ], 34)
  ], 64))
}
}

})